export default "__VITE_ASSET__B_5MR5Oi__"